<template>
  <div>
    <div class="checkout-finished" ref="checkoutFinished" v-if="showThankYou">
      <h1 class="title has-text-centered is-size-2 mt-5">{{ $t('notices.thanks-for-your-order') }}</h1>
      <div class="columns has-text-centered">
        <div class="column is-6 is-offset-3">
          <p>
            {{ $t('notices.voucher-printable-after-payment') }}
          </p>
        </div>
      </div>
    </div>
    <div v-if="loaded && !accessable">
      <div class="container u-p15">
        <div class="notification is-danger">{{ $t('notices.order-does-not-exist') }}</div>
      </div>
    </div>
    <div v-if="loaded && accessable && order && order.id">
      <div v-if="!order.isUnclaimed" class="has-text-centered">
        <!-- <router-link :to="{name: 'userorders'}">Zurück zur Bestellübersicht</router-link> -->

        <b-button tag="router-link" :to="{name: 'userorders'}" type="is-text">
          {{ $t('general.back-to-order-overview') }}
        </b-button>
      </div>
      <Order :order="order" />
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import store from './_store'
import Order from './_components/Order'
//import Gtm from '@/common/google-tag-manager'
export default {
  name: 'OrderModule',
  components: {
    Order,
  },
  computed: {
    ...mapGetters({
      order: '$_order/order',
      accessable: '$_order/isAccessable',
      loaded: '$_order/loaded',
      waiting: '$_order/waitingForGeneration',
      needsPaymenRetry: '$_order/needsPaymenRetry',
    }),
  },
  data() {
    return {
      showThankYou: false,
      polling: null,
    }
  },
  beforeCreate() {
    const STORE_KEY = '$_order'
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store)
    }
  },
  created() {
    if (this.$route.name == 'order-complete') {
      this.showThankYou = true
    }
    if (this.$route.params.id && this.$route.params.key) {
      this.$store.dispatch('$_order/getOrder', {
        id: this.$route.params.id,
        key: this.$route.params.key,
      })
      this.startPaymentRetryIfNeeded()
      if (this.waiting) {
        this.pollData()
      }
    }
  },
  methods: {
    startPaymentRetryIfNeeded() {
      if (this.needsPaymenRetry) {
        this.$buefy.toast.open({
          duration: 2500,
          message: this.$t('errors.payment-declined-retryable'),
          position: 'is-bottom',
          type: 'is-danger',
        })
        if (this.polling) {
          clearInterval(this.polling)
        }
        setInterval(() => {
          this.$router.push({name: 'checkout'})
        }, 2400)
      }
    },
    pollData() {
      if (this.waiting) {
        this.polling = setInterval(() => {
          this.$store.dispatch('$_order/getOrder', {
            id: this.$route.params.id,
            key: this.$route.params.key,
          })
          this.startPaymentRetryIfNeeded()
        }, 5000)
      }
    },
  },
  mounted() {},
  watch: {
    waiting(newValue) {
      if (newValue) {
        this.pollData()
      } else {
        if (this.polling) {
          clearInterval(this.polling)
        }
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.polling)
  },
  metaInfo() {
    return {
      title: 'Ihre Gutscheine',
      meta: [{name: 'description', content: 'Drucken Sie Ihre Gutscheine umgehend nach Bezahlung!'}],
    }
  },
}
</script>
